module.exports = __webpack_public_path__ + "img/contact2.cb841b93.jpg";